import type { TFunction } from 'i18next';
import type { U2000DeleteHandlersReturn } from '../../../u2000Core/hooks/handler/U2000UseDeleteHandlers';
import U2000DeleteRecordDialog from '../../../u2000Core/components/dialog/U2000DeleteRecordDialog';
import type { U3208AiRagCorpusSearchRow } from '../../U3208Service';

interface U3208AiRagCorpusDeleteDlgProps {
  handleDelete: U2000DeleteHandlersReturn<U3208AiRagCorpusSearchRow>;
  t: TFunction;
  NS: string;
}

function U3208AiRagCorpusDeleteDlg({ handleDelete, t, NS }: U3208AiRagCorpusDeleteDlgProps) {
  if (!handleDelete.isDialogDeleteOpen) return null;

  const rows = handleDelete.selectedRows();
  const count = rows.length;

  return (
    <U2000DeleteRecordDialog
      isOpen={handleDelete.isDialogDeleteOpen}
      onClose={handleDelete.handleDeleteCloseDlg}
      title={t('lblDeleteDlgTitle', { ns: NS })}
    >
      <p className="mb-4">
        {t(count === 1 ? 'msgDeleteCorpus' : 'msgDeleteCorpus_other', {
          count,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {rows.map((row, index, array) => (
          <span key={row.id} className="inline-block text-gray-800">
            {`${row.code ?? row.id}${row.title ? ` — ${row.title}` : ''}`}
            {index < array.length - 1 && ', '}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3208AiRagCorpusDeleteDlg;
